import React from "react";
import MedicationInformation from "components/pages/transmissions/modal/patient/tabs/medicalInformation/MedicationInformation/MedicationInformation";
import PatientHistoryInformation from "components/pages/transmissions/modal/patient/tabs/medicalInformation/PatientHistoryInformation/PatientHistoryInformation";

const MedicalInformation = () => {
  return (
    <>
      <MedicationInformation />
      <PatientHistoryInformation />
    </>
  );
};

export default MedicalInformation;
